import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=4d672f85&"
import script from "./rate.vue?vue&type=script&lang=ts&"
export * from "./rate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports